import { render, staticRenderFns } from "./Stamp.vue?vue&type=template&id=099b35a2&"
import script from "../../models/analysis/stamp.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/stamp.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports